import React from "react";
import RecruiterLayerBlueprint from "components/blueprints/RecruiterLayerBlueprint";
import RecruiterDashboardOverview from "./components/RecruiterDashboardOverview";
import RecruiterDashboardClientsTable from "./components/RecruiterDashboardClientsTable";
import RecruiterDashboardOrdersTable from "./components/RecruiterDashboardOrdersTable";
import RecruiterDashboardOrientation from "./components/RecruiterDashboardOrientation";
import RecruiterDashboardRecentActivity from "./components/RecruiterDashboardRecentActivity";

function RecruiterDashboardPage() {
  return (
    <div className="bg-gray-100 py-2 min-h-screen">
      <div className="container mx-auto my-6 flex">
        <section id="left" className="w-1/2 pr-2">
          <RecruiterDashboardOverview />
          <RecruiterDashboardClientsTable />
          <RecruiterDashboardOrdersTable />
        </section>
        <section id="right" className="w-1/2 pl-2">
          <RecruiterDashboardOrientation />
          <RecruiterDashboardRecentActivity />
        </section>
      </div>
    </div>
  );
}

export default RecruiterLayerBlueprint(RecruiterDashboardPage);
